import React from 'react';
import { Slider, Rail, Handles, Tracks, Ticks } from 'react-compound-slider';
import { SliderRail, Handle, Track, Tick } from './components';
import PropTypes from 'prop-types';

const sliderStyle = {
  // Give the slider some width
  position: 'relative',
  width: '100%',
  height: 50,
};

const SliderTracketProps = {
  values: PropTypes.arrayOf(PropTypes.number).isRequired,
  step: PropTypes.number,
  mode: PropTypes.number,
  domain: PropTypes.arrayOf(PropTypes.number).isRequired,
  onChange: PropTypes.func,
  onUpdate: PropTypes.func,
  style: PropTypes.instanceOf(React.CSSProperties),
  customLabel: PropTypes.func,
  disabled: PropTypes.bool,
  domainTicks: PropTypes.arrayOf(PropTypes.number),
  tickCount: PropTypes.number,
  customTicks: PropTypes.func,
};

const SliderTracker = (props) => {
  const {
    values,
    step,
    mode,
    domain,
    onChange,
    onUpdate,
    style,
    customLabel,
    disabled,
    domainTicks,
    tickCount,
    customTicks,
  } = props;

  return (
    <Slider
      disabled={disabled}
      mode={mode}
      step={step}
      domain={domain}
      rootStyle={{ ...sliderStyle, ...style }}
      onUpdate={onUpdate}
      onChange={onChange}
      values={values}
    >
      <Rail>{({ getRailProps }) => <SliderRail getRailProps={getRailProps} />}</Rail>
      <Handles>
        {({ handles, getHandleProps }) => (
          <div className='slider-handles'>
            {handles.map((handle) => (
              <Handle
                key={handle.id}
                handle={handle}
                domain={domain}
                disabled={disabled}
                getHandleProps={getHandleProps}
              />
            ))}
          </div>
        )}
      </Handles>
      <Tracks right={false}>
        {({ tracks, getTrackProps }) => (
          <div className='slider-tracks'>
            {tracks.map(({ id, source, target }) => (
              <Track
                key={id}
                source={source}
                target={target}
                getTrackProps={getTrackProps}
                disabled={disabled}
              />
            ))}
          </div>
        )}
      </Tracks>
      <Ticks count={tickCount || 1} values={domainTicks || domain}>
        {({ ticks }) => {
          return (
            <div className='slider-ticks'>
              {ticks.map((tick, index) => {
                if (customTicks) {
                  return customTicks(tick, index, ticks);
                }
                return (
                  <Tick
                    key={tick.id}
                    tick={tick}
                    count={ticks.length}
                    index={index}
                    customLabel={customLabel}
                  />
                );
              })}
            </div>
          );
        }}
      </Ticks>
    </Slider>
  );
};

SliderTracker.defaultProps = {
  customLabel: null,
  domain: [0, 100],
  step: 1,
  mode: 1,
  values: [0],
};

SliderTracker.propTypes = SliderTracketProps;
export default React.memo(SliderTracker);
